module.exports = __webpack_public_path__ + "files/bb43a2d14b9f52b2ebaa4929a10da521.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-6.png
// module id = 1459
// module chunks = 60